export default function PrescriptionConcernsBanner({ concerns = [] }) {
  if (!concerns.length) return null;
  return (
    <section role="status" aria-live="polite" style={{
      border: "2px solid #b42318", borderRadius: 10, background: "#fff4f2",
      padding: "18px 20px", marginBottom: 20, color: "#7a271a", lineHeight: 1.6,
    }}>
      <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 10px", color: "#b42318" }}>
        Distributor review required
      </h3>
      <ul style={{ paddingLeft: 22, margin: "0 0 12px" }}>
        {concerns.map((issue, index) => <li key={`${issue.code}-${index}`} style={{ margin: "8px 0" }}>{issue.message}</li>)}
      </ul>
      <p style={{ margin: 0 }}>
        You can create this order as received. These concerns will be included in the confirmation email.
        {" "}<strong>The distributor must resolve them before approving the order.</strong>
        {" "}The original ordered products and prescription will be retained.
      </p>
    </section>
  );
}
